import type { Holding } from '@/hooks/portfolio/usePortfolio';
import type { WatchlistItem } from '@/hooks/useWatchlist';
import { Period } from '@/utilities/timeSeriesPeriodMap';

export function useCompanyPeriodReturn(
  company: WatchlistItem['company'] | Holding['company'],
  period: Period
) {
  if (period === '1M') {
    return { period, return: company.analysisValue?.return30d ?? null };
  }

  if (period === '3M') {
    return { period, return: company.analysisValue?.return90d ?? null };
  }

  if (period === '1Y') {
    return { period, return: company.analysisValue?.return1yAbs ?? null };
  }

  return { period, return: null };
}
